import { FC } from 'react'
import * as cn from 'classnames'
import { CategoryId } from 'interfaces/meta'
import { CATEGORY_WORDING_MAP, NO_INTEREST_CATEGORIES } from 'constants/accounts'
import { AccountType } from 'interfaces/accounts'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

type NoAccountsCopyProps = {
  categoryId?: CategoryId
  type: AccountType
  standalone: boolean
}

const NoAccountsCopy: FC<NoAccountsCopyProps> = (props) => {
  const { categoryId, type, standalone } = props
  const isAssetCategory = type === 'assets'
  const isHomeCarCategory = isAssetCategory && categoryId && NO_INTEREST_CATEGORIES.has(categoryId)
  const noAccountsCopy = categoryId && CATEGORY_WORDING_MAP[categoryId]
    ? CATEGORY_WORDING_MAP[categoryId]
    : (isAssetCategory ? 'asset' : 'debt')

  const settingsAccountsLink = (
    <NavigationLink to='linkedaccounts' className='noAccountsCopySettingsLink'>
      settings
    </NavigationLink>
  )

  const rootClassName = cn('noAccountsCopy', {
    noAccountsCopyStandalone: standalone,
  })

  if (isHomeCarCategory) {
    const assetType = categoryId ? `${ noAccountsCopy }` : `selected ${ noAccountsCopy } type`
    return (
      <span className={ rootClassName }>
        <div className='noAccountsCopyText'>This section does not apply for { assetType }.</div>
      </span>
    )
  }

  return (
    <span className={ rootClassName }>
      <div className='noAccountsCopyText'>You have not linked any { noAccountsCopy } accounts yet.</div>
      <div className='noAccountsCopyText'>You can link accounts from the { settingsAccountsLink } page.</div>
    </span>
  )
}

export default NoAccountsCopy
